import { Category } from "@faire/deprecated-retailer-visitor-shared/models/Category/Category";
import { LoggedOutSuppliersPageCurrentCategoryProvider } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/Context/useLoggedOutSuppliersPageCurrentCategory";
import { LoggedOutSuppliersPageCurrentNavigationPathProvider } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/Context/useLoggedOutSuppliersPageCurrentNavigationPath";
import { LoggedOutSuppliersBrandsSearchRequestProvider } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/BrandsSearchContext/LoggedOutSuppliersBrandsSearchRequestContext";
import { LoggedOutSuppliersPage } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/LoggedOutSuppliersPage";
import * as React from "react";

export const SuppliersPage: React.FC<{
  category: Category;
  navigationPath: string;
}> = ({ category, navigationPath }) => {
  return (
    <LoggedOutSuppliersPageCurrentCategoryProvider value={category}>
      <LoggedOutSuppliersPageCurrentNavigationPathProvider
        value={navigationPath}
      >
        <LoggedOutSuppliersBrandsSearchRequestProvider>
          <LoggedOutSuppliersPage />
        </LoggedOutSuppliersBrandsSearchRequestProvider>
      </LoggedOutSuppliersPageCurrentNavigationPathProvider>
    </LoggedOutSuppliersPageCurrentCategoryProvider>
  );
};
